module.exports = __webpack_public_path__ + "static/media/diamond.5cc30ae7.gif";